import script from "./DashboardQuickLink.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardQuickLink.vue?vue&type=script&setup=true&lang=js"

import "./DashboardQuickLink.vue?vue&type=style&index=0&id=71e9944a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e9944a"]])

export default __exports__